<div class="ifa-list-page">
  <div class="conatiner-page-header">IFA List</div>
  <div class="ifa-list-tag-action align-h">
    <div class="form-group stretch margin-bottom-0">
      <mat-form-field>
        <input
          matInput
          type="text"
          placeholder="Search by name"
          [(ngModel)]="searchText"
          (input)="reset(searchText)"
        />
      </mat-form-field>
    </div>
    <a mat-button (click)="onChangeSearchInput(searchText)">Search</a>
    <div class="stretch text-right">
      <a mat-button (click)="openCreateTagDialog()">Create Tag</a>
      <a mat-button (click)="openDeleteTagDialog('DELETE')">Delete Tag</a>
    </div>
  </div>

  <!--IFA LIST CONTAINER-->
  <app-ifa-list-container [ifaList]="ifaList" (refersh)="onIfaRefresh()" ></app-ifa-list-container>
  <div class="no-data" *ngIf="ifaList?.length === 0 ">No data found!!!</div>
  <mat-paginator [length]="totalRecords" 
                 [pageSize]="pageSize" 
                 [pageSizeOptions]="pageSizeOptions" 
                 (page)="onPageChange($event)">
  </mat-paginator>
</div>
